import { DashboardAudit } from '@/pages/DashboardAudit'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$orgId/dashboard/audit')({
  component: DashboardAudit,
  meta: () => [{ title: 'Audit' }],
})
